import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';


@Component({
  selector: 'app-subject-paper',
  templateUrl: './subject-paper.component.html',
  styleUrls: ['./subject-paper.component.css'],
  providers: [HelperService] 
})

export class SubjectPaperComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  @ViewChild(DataTableDirective)
 @ViewChild("fileInput") fileInput;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas: any= [];
  dtElement: DataTableDirective;

  id=0;
  loader=false;
  syllabus_id;
  gradeid;
  syllabusname;
  gradename;
  subjectid;
  subjectname;
  grade;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
				   private headers: Headers = new Headers({
				   'Accept': 'application/json',
				   'Authorization': "Bearer "+this.user_token
         });
         awsurl;
  constructor(private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,private cookie:CookieService) {
  	this.activatedRouter.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.syllabus_id = params['syllabus_id'];
      this.gradeid = params['gradeid'];
      this.subjectid = params['subject_id'];
      this.grade = params['grade'];
    });
  }

  ngOnInit() {
     
    this.awsurl = this.helper.aws_url;
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/subject_paper/'+this.id,{ headers: this.headers })
      
      .subscribe(data => {
        this.datas = JSON.parse(data['_body']);
      
          this.dtTrigger.next();
        
       
      });
      this.http.get(this.helper.base_url+'http/get/syllabus/'+this.syllabus_id,{ headers: this.headers })
      .subscribe(
         
        (data) => {
          let body = JSON.parse(data['_body']);
          //console.log(body);
          this.syllabusname = body.data[0].name;
          //console.log(this.syllabusname);
          //alert(this.syllabusname);
          // this.refresh();
        }, //For Success Response
        err => {console.error(err)} //For Error Response
    );
    this.http.get(this.helper.base_url+'http/get/gradedetails/'+this.gradeid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.gradename = body.data[0].name;
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );
  this.http.get(this.helper.base_url+'http/get/subjectsdetails/'+this.subjectid,{ headers: this.headers })
    .subscribe(
       
      (data) => {
        let body = JSON.parse(data['_body']);
        //console.log(body);
        this.subjectname = body.data[0].name;
        //console.log(this.gradename);
        //alert(this.syllabusname);
        // this.refresh();
      }, //For Success Response
      err => {console.error(err)} //For Error Response
  );

  let user=this.cookie.get('user_id');
  this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
  
  .subscribe(data => {
    this.user_permissions = JSON.parse(data['_body']);
   //console.log(this.user_permissions);
      
   
  });
  }

 
  deleteClick(id){
  
    let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
     // this.snackbar.open('Are you sure!', 'Delete', {
        duration: 3000,
        extraClasses:  ['warning-snackbar'],
      }).onAction().subscribe(() => {
        this.http.get(this.helper.base_url+'http/delete/subject_paper/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh(false,'Paper Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      );   
      });
  }


 refresh(val=false,msg=''){
   
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["subject_paper/"+this.id,this.syllabus_id,this.gradeid,this.subjectid,this.grade]));
      
 }

 add_form(addForm: NgForm){
   

  let body = new FormData();

let fi = this.fileInput.nativeElement;
body.append('file', fi.files[0]);
 body.append('name', addForm.value.name);
 body.append('no_of_q', addForm.value.no_of_q);
 body.append('mark', addForm.value.mark);
 body.append('hours', addForm.value.hours);
 body.append('year', addForm.value.year);
  this.loader=true;
   this.http.post(this.helper.base_url+'http/add/subject_paper/'+this.id, body,{ headers: this.headers })
   .subscribe(

     (data) =>{
       this.loader=false;
       this.refresh(false,'Paper added successfully');
    
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }


  private extractData(res: Response) {
    const body = res.json();
    return body.data || {};
  }
  backbtn(){
   window.history.back();
 }
}



// WEBPACK FOOTER //
// ./src/app/subject-paper/subject-paper.component.ts